export default __webpack_public_path__ + "static/media/CardBackBlue.d0829c51.png";